import { ThemeColors } from "@/config/colors";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import Image from "next/image";

export function PurchaseWithTokenFinished() {
	return (
		<>
			<Container component="header" maxWidth="xs" style={{ padding: 0 }}>
				<Box
					px={2}
					height={64}
					display="flex"
					alignItems="center"
					justifyContent="space-between"
					bgcolor={ThemeColors[0].colors.primary[500]}
				>
					<Image
						src="/logo-white.png"
						width={130}
						height={27}
						alt="ケアミーのロゴ"
					/>
				</Box>
			</Container>

			<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
				<Box width="100%" my={8}>
					<Stack flexDirection="column" px={4}>
						<Typography
							variant={"h6"}
							component={"p"}
							textAlign="center"
							mb={4}
						>
							購入が完了しました
						</Typography>

						<Button
							href="https://coyomiv2.page.link/open_app_from_web"
							variant="contained"
						>
							アプリを開く
						</Button>
					</Stack>
				</Box>
			</Container>
		</>
	);
}
